export default {
  path: '/material_products',
  name: 'material_products',
  component: () => import('../components/materialproduct/Layout'),
  redirect: { name: 'MaterialProductList' },
  meta: {
    breadcrumb: 'profile.material.products',
  },
  children: [
    {
      name: 'MaterialProductList',
      path: '',
      component: () => import('../views/materialproduct/List'),
      meta: {
        breadcrumb: 'global.list',
      },
    },
    {
      name: 'MaterialProductCreate',
      path: 'new',
      component: () => import('../views/materialproduct/Create'),
      meta: {
        breadcrumb: 'global.add',
      },
    },
    {
      name: 'MaterialProductUpdate',
      path: ':id/edit',
      component: () => import('../views/materialproduct/Update'),
      meta: {
        breadcrumb: 'profile.material.product',
      },
    },
    {
      name: 'MaterialProductShow',
      path: ':id',
      component: () => import('../views/materialproduct/Show'),
      meta: {
        breadcrumb: 'profile.material.product',
      },
    }
  ]
};
